import * as actions from '../actions/actionCatalog';
import { AxiosResponse } from 'axios';
import { combineReducers } from 'redux';

export interface WorklistNode {
  pk: number;
  forwardMethod: 'UPS_RS' | 'DICOM';
  upsRsEndpoint: string;
  enabled: boolean;
  authHeader: string;
  displayName: string;
  dicomUrl: string;
  headers: Map<string, string>;
}

export const WORKLIST_MAPPING_ANY_MATCH = "$$ANY$$";

export interface WorklistScriptMapping {
  pk: number;
  callingAet: string;
  worklistNode: string;
  scriptName: string;
  orderIndex: number;
  enabled: boolean;
}

type GetWorklistNodesFulfilled = {
  type: typeof actions.GET_WORKLIST_NODES_FULFILLED;
  response: AxiosResponse<WorklistNode[]>;
};

type GeWorklistScriptsMappingsFulfilled = {
  type: typeof actions.GET_WORKLIST_SCRIPTS_MAPPINGS_FULFILLED;
  response: AxiosResponse<WorklistScriptMapping[]>;
};

function nodes(state: WorklistNode[] = [], action: GetWorklistNodesFulfilled): WorklistNode[] {
  switch (action.type) {
    case actions.GET_WORKLIST_NODES_FULFILLED:
      return action.response.data;
    default:
      return state;
  }
}

function scriptsMappings(
  state: WorklistScriptMapping[] = [],
  action: GeWorklistScriptsMappingsFulfilled
): WorklistScriptMapping[] {
  switch (action.type) {
    case actions.GET_WORKLIST_SCRIPTS_MAPPINGS_FULFILLED:
      return action.response.data;
    default:
      return state;
  }
}

export default combineReducers({ nodes, scriptsMappings });

export type WorklistState = {
  nodes: ReturnType<typeof nodes>;
  scriptsMappings: ReturnType<typeof scriptsMappings>;
};
